/* tslint:disable */
var TComboNoCombinationSPSlipMode = (function()
{
    "use strict";
    var api = <any>{};

    api.buildHeader = function ()
    {
        return "";
    };

    return api;
}());

window.TComboNoCombinationSPSlipMode = TComboNoCombinationSPSlipMode;